export default __webpack_public_path__ + "static/media/logo-geral-agencia-rosa.7b8357b6.png";